<div class="container">
  <mat-spinner></mat-spinner>
</div>